/* Progressive option pickers. Shopify's variant select remains the source of truth. */
class C4ProductOptions extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const product = this.closest('c4-product');
    const variant = product.querySelector('[data-variant]');
    const pickers = [...this.querySelectorAll('[data-product-option]')];
    const variants = [...variant.options].map((option) => ({
      option,
      values: JSON.parse(option.dataset.options || '[]'),
    }));
    if (!pickers.length || variants.some((item) => item.values.length !== pickers.length)) return;
    const sync = () => {
      const current = variants.find((item) => item.option.selected);
      pickers.forEach((picker, index) => {
        picker.value = current.values[index];
        // Restrict later options by earlier selections; retain sold-out combinations.
        [...picker.options].forEach((option) => {
          option.disabled = !variants.some(
            (item) =>
              item.values[index] === option.value &&
              item.values.slice(0, index).every((value, i) => value === current.values[i]),
          );
        });
        const field = picker.closest('[data-option-field]');
        field.querySelectorAll('[data-swatch]').forEach((radio) => {
          radio.checked = radio.value === picker.value;
          radio.disabled = [...picker.options].find(
            (option) => option.value === radio.value,
          ).disabled;
        });
        /* Ground (the grind sizes' label) opens the first size this bag size has. */
        field.querySelectorAll('.option-tile--ground').forEach((ground) => {
          const first = ground.parentElement.querySelector('.option-ground input:enabled');
          if (first) ground.htmlFor = first.id;
        });
        const label = field.querySelector('[data-swatch-label]');
        if (label)
          label.textContent = label.dataset.strip
            ? picker.value.replace(label.dataset.strip, '').trim() || picker.value
            : picker.value;
      });
      const media = product
        .closest('section')
        .querySelector(`.product-media[data-media-id="${current.option.dataset.mediaId}"]`);
      if (media) {
        const track = media.parentElement;
        track.scrollLeft += media.getBoundingClientRect().left - track.getBoundingClientRect().left;
      }
    };
    this.addEventListener(
      'change',
      (event) => {
        let target = event.target;
        if (target.matches('[data-swatch]')) {
          const picker = target
            .closest('[data-option-field]')
            .querySelector('[data-product-option]');
          picker.value = target.value;
          target = picker;
        }
        const index = pickers.indexOf(target);
        if (index < 0) return;
        const candidates = variants.filter((item) =>
          item.values.slice(0, index + 1).every((value, i) => value === pickers[i].value),
        );
        const match =
          candidates.find((item) => item.values.every((value, i) => value === pickers[i].value)) ||
          candidates.find((item) => item.option.dataset.available === 'true') ||
          candidates[0];
        if (!match) return;
        variant.value = match.option.value;
        variant.dispatchEvent(new Event('change', { bubbles: true }));
      },
      { signal: this.abort.signal },
    );
    variant.addEventListener('change', sync, { signal: this.abort.signal });
    sync();
    product.querySelector('[data-variant-form]').hidden = true;
    this.hidden = false;
  }
  disconnectedCallback() {
    this.abort?.abort();
  }
}
if (!customElements.get('c4-product-options'))
  customElements.define('c4-product-options', C4ProductOptions);
